import { Moment } from 'moment';
import * as Yup from 'yup';
import { Model, ModelClass } from './Model';
import { Float } from './Types';
import { User, UserType, UserValidationRules } from './User';
import { Wholesaler, WholesalerType } from './Wholesaler';

export interface SalesmanType extends ModelClass {
    last_name: string;
    first_name: string;
    id: number;
    created_at: Moment;
    updated_at: Moment;
    total: Float;
    cost: Float;
    profit: Float;
    deductions: Float;
    bonus: Float;
    commission: Float;
    salesmen_commission: Float;
    user: UserType;
    orders: number;
    status: string;
    referral_code: string;
    wholesaler: WholesalerType;
    lakeshore_id: number;
}

export const Salesman = Model<SalesmanType>('Salesman', {
    endpoint: 'apparel-salesmen',
})`
    id:Int;
    created_at:DateTime;
    updated_at:DateTime;
    total:Float;
    cost:Float;
    profit:Float;
    deductions:Float;
    bonus:Float;
    commission:Float;
    salesmen_commission:Float;
    inbound_commission:Float;
    outbound_commission:Float;
    returning_commission:Float;
    commission_based_on_inbound: Int;
    commission_based_on_outbound: Int;
    commission_based_on_returning: Int;
    user:${User};
    orders:Int;
    status: String;
    referral_code: String;
    wholesaler: ${Wholesaler};
    lakeshore_id: Int;
`;

const UserValidationUpdate = Yup.object({
    ...UserValidationRules,
    phone: Yup.number().required('Phone is required').typeError('Phone must be a number'),
});

export const SalesmanValidation = Yup.object().shape({
    user: UserValidationUpdate,
    wholesaler_id: Yup.mixed().when('is_wholesaler_sales_rep', {
        is: 'yes',
        then: Yup.number().nullable().required('wholesaler is required'),
        otherwise: Yup.number().nullable(),
    }),
    lakeshore_id: Yup.number().nullable().required('Sales rep id is required'),
    is_wholesaler_sales_rep: Yup.string(),
});
